import { render } from "./copy-dataset.vue?vue&type=template&id=d6447976"
import script from "./copy-dataset.vue?vue&type=script&lang=js"
export * from "./copy-dataset.vue?vue&type=script&lang=js"

import "./copy-dataset.vue?vue&type=style&index=0&id=d6447976&lang=css"
script.render = render

export default script